// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";
import GetConfigWhiteLabel from "../services/config";

const config = GetConfigWhiteLabel();
import packageJson from "../../package.json";

const initialNavigation = () => {
  const item = `Bem vindo ao ${config.name}`;
  return item ? item : {};
};

const initialIconNavigation = () => {
  const item = config.favicon
    ? config.favicon
    : "https://cdn-vulcan-us.s3.us-east-1.amazonaws.com/cartopay-stage/logo_empresa.png";
  return item ? item : {};
};

const initialLogoNavigation = () => {
  const item = config.logo_empresa
    ? config.logo_empresa
    : "https://cdn-vulcan-us.s3.us-east-1.amazonaws.com/cartopay-stage/logo_empresa.png";
  return item ? item : {};
};

const initialLogoNavigationLight = () => {
  const item = config.logo_empresa
    ? config.logo_empresa_light
    : "https://cdn-vulcan-us.s3.us-east-1.amazonaws.com/cartopay-stage/logo_empresa.png";
  return item ? item : {};
};

const initialLogoNavigationDark = () => {
  const item = config.logo_empresa
    ? config.logo_empresa_dark
    : "https://cdn-vulcan-us.s3.us-east-1.amazonaws.com/cartopay-stage/logo_empresa.png";
  return item ? item : {};
};

const initialLogoSmallLightNavigation = () => {
  const item = config.logo_empresa_small_light
    ? config.logo_empresa_small_light
    : "https://www.carto.com.br/assets/img/favicon.png";
  return item ? item : {};
};

const initialLogoSmallDarkNavigation = () => {
  const item = config.logo_empresa_small_dark
    ? config.logo_empresa_small_dark
    : "https://www.carto.com.br/assets/img/favicon.png";
  return item ? item : {};
};

const initialImageNavigation = () => {
  const item = config.cover_login ? config.cover_login : "ImageHero_Carto.png";
  return item ? item : {};
};

const appVersion = () => {
  const item = packageJson.version ? packageJson.version : "0.0.0";
  return item ? item : {};
};

const ambientType = () => {
  const item = config.ambient ? config.ambient : "H";
  return item ? item : {};
};

const facebook = () => {
  const item = config.url_facebook ? config.url_facebook : "";
  return item ? item : "";
};

const instagram = () => {
  const item = config.url_instagram ? config.url_instagram : "";
  return item ? item : "";
};

const linkedin = () => {
  const item = config.url_linkedin ? config.url_linkedin : "";
  return item ? item : "";
};

export const navigationSlice = createSlice({
  name: "navigationStep",
  initialState: {
    initialStep: initialNavigation(),
    iconInitialStepNavigation: initialIconNavigation(),
    logoInitialStepNavigation: initialLogoNavigation(),
    logoInitialStepNavigationLight: initialLogoNavigationLight(),
    logoInitialStepNavigationDark: initialLogoNavigationDark(),
    logoInitialStepNavigationSmallLight: initialLogoSmallLightNavigation(),
    logoInitialStepNavigationSmallDark: initialLogoSmallDarkNavigation(),
    imageInitialStepNavigation: initialImageNavigation(),
    facebook: facebook(),
    instagram: instagram(),
    linkedin: linkedin(),
    secondStepNavigation: "",
    iconSecondStepNavigation: "",
    thirdStepNavigation: "",
    version: appVersion(),
    sessionTimer: 14.9,
    ambient: ambientType(),
  },
  reducers: {
    handleNavigation: (state, action) => {
      state.initialStep = action.payload;
    },
    handleIconInitialNavigation: (state, action) => {
      state.iconInitialStepNavigation = action.payload;
    },
    handleLogonInitialNavigation: (state, action) => {
      state.logoInitialStepNavigation = action.payload;
    },
    handleLogonInitialNavigationDark: (state, action) => {
      state.logoInitialStepNavigationDark = action.payload;
    },
    handleLogonInitialNavigationSmall: (state, action) => {
      state.logoInitialStepNavigationSmall = action.payload;
    },
    handleLogonInitialNavigationSmallDark: (state, action) => {
      state.logoInitialStepNavigationSmallDark = action.payload;
    },
    handleNavigationSecond: (state, action) => {
      state.secondStepNavigation = action.payload;
    },
    handleIconSecondStepNavigation: (state, action) => {
      state.iconSecondStepNavigation = action.payload;
    },
    handleNavigationThird: (state, action) => {
      state.thirdStepNavigation = action.payload;
    },
    handleSessionTimer: (state, action) => {
      state.sessionTimer = action.payload;
    },
    handleFacebook: (state, action) => {
      state.facebook = action.payload;
    },
    handleInstagram: (state, action) => {
      state.instagram = action.payload;
    },
    handleLinkedin: (state, action) => {
      state.linkedin = action.payload;
    },
  },
});

export const {
  handleNavigation,
  handleNavigationSecond,
  handleIconSecondStepNavigation,
  handleIconInitialNavigation,
  handleNavigationThird,
  handleSessionTimer,
  handleLogonInitialNavigation,
  handleLogonInitialNavigationDark,
  handleLogonInitialNavigationSmall,
  handleLogonInitialNavigationSmallDark,
  handleFacebook,
  handleInstagram,
  handleLinkedin,
} = navigationSlice.actions;

export default navigationSlice.reducer;
